export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/encode.worker.0318009a.worker.js");
}
